export const it = {
  // Header
  header: {
    home: "Home",
    listen: "Ascoltaci",
    drive: "Drive",
    about: "Chi Siamo",
    schedule: "Palinsesto",
    podcasts: "Podcast",
    contact: "Contatti"
  },
  
  // Home Page
  home: {
    welcome: "Benvenuti su Rete Italia",
    subtitle: "La voce italiana in Australia. Musica, cultura e informazione 24 ore su 24.",
    liveRadio: "Radio Live",
    liveRadioDesc: "Ascolta la radio in diretta streaming",
    liveVideo: "Video Live",
    liveVideoDesc: "Guarda i nostri programmi in video",
    podcastTitle: "Podcast",
    podcastDesc: "Ascolta quando vuoi",
    everywhere: "Ovunque",
    everywhereDesc: "Disponibile su tutti i dispositivi",
    audioStreaming: "Radio Streaming",
    videoStreaming: "Video Streaming",
    nowPlaying: "Ora in onda su Rete Italia",
    liveVideoLabel: "Video Streaming Rete Italia",
    ctaTitle: "Unisciti alla Community di Rete Italia",
    ctaSubtitle: "Rimani sempre connesso con la cultura italiana in Australia",
    contactUs: "Contattaci",
    explorePodcasts: "Esplora i Podcast"
  },
  
  // About Page
  about: {
    title: "Chi Siamo",
    subtitle: "La rete radiofonica nazionale italiana dell'Australia, che collega le comunità attraverso notizie, cultura e musica.",
    storyTitle: "La Storia di Rete Italia",
    story1: "Rete Italia è la rete radiofonica nazionale in lingua italiana dell'Australia, creata per connettere le comunità italiane in tutto il paese attraverso notizie, cultura, musica e conversazione.",
    story2: "Rete Italia ha iniziato a trasmettere nel 1994, lanciandosi prima nel New South Wales con servizi a Sydney, Gosford e Wollongong. Fin dall'inizio, la visione era chiara: creare un servizio forte e professionale in lingua italiana che riflettesse la voce, le esperienze e gli interessi degli italo-australiani.",
    story3: "Poco dopo il lancio nel NSW, Rete Italia si è espansa a Melbourne, riconoscendo l'importanza di servire la più grande comunità italiana dell'Australia. Questo ha segnato l'inizio della crescita della rete in un servizio veramente nazionale.",
    story4: "Nel tempo, Rete Italia ha continuato a espandersi, stabilendo frequenze in tutte le capitali australiane e nei principali centri regionali dove vivono e lavorano grandi comunità italiane. Questa portata nazionale ha permesso agli italo-australiani, ovunque si trovino, di rimanere connessi attraverso una lingua e una cultura condivise.",
    programmingTitle: "La programmazione di Rete Italia comprende:",
    prog1: "Notizie e attualità italiane e australiane",
    prog2: "Discussioni radiofoniche e comunitarie",
    prog3: "Sport, con una forte attenzione al calcio",
    prog4: "Musica dall'Italia e dalla diaspora italiana",
    prog5: "Programmazione culturale, religiosa e comunitaria",
    story5: "Con il cambiare delle generazioni, Rete Italia si è evoluta con il suo pubblico — continuando a servire i migranti di prima generazione mentre coinvolge anche gli ascoltatori più giovani che bilanciano l'eredità italiana con la vita australiana contemporanea.",
    story6: "Oggi, Rete Italia rimane una voce fidata per gli italo-australiani, unendo le comunità attraverso piattaforme radio e digitali, e continuando la sua missione di informare, intrattenere e connettere gli italiani in tutta l'Australia.",
    yearsOfPassion: "Anni di Passione",
    passionTitle: "Passione",
    passionDesc: "Amiamo ciò che facciamo e lo facciamo con tutto il cuore",
    communityTitle: "Comunità",
    communityDesc: "Uniamo le persone attraverso la cultura e la musica",
    connectionTitle: "Connessione",
    connectionDesc: "Un ponte tra Italia e Australia",
    qualityTitle: "Qualità",
    qualityDesc: "Contenuti di eccellenza per i nostri ascoltatori",
    teamTitle: "Il Nostro Team",
    teamDesc: "Un team di professionisti appassionati, dedicati a portare il meglio della cultura italiana in Australia ogni singolo giorno.",
    djsTitle: "DJ & Presentatori",
    djsDesc: "Voci professionali che danno vita ai nostri programmi",
    techTitle: "Team Tecnico",
    techDesc: "Esperti che garantiscono streaming di qualità 24/7",
    editorialTitle: "Redazione",
    editorialDesc: "Giornalisti e content creator per contenuti sempre freschi"
  },
  
  // Schedule Page
  schedule: {
    title: "Palinsesto",
    subtitle: "Scopri i nostri programmi quotidiani. Musica, informazione e intrattenimento per tutta la giornata.",
    todayPrograms: "Programmi di",
    with: "Con",
    note: "Nota Importante",
    noteText: "Il palinsesto può subire variazioni. Resta sintonizzato su Rete Italia per aggiornamenti in tempo reale!",
    loading: "Caricamento..."
  },
  
  // Podcast Page
  podcast: {
    title: "Podcast",
    subtitle: "Ascolta i nostri podcast quando vuoi, dove vuoi. Contenuti esclusivi sempre disponibili.",
    episodes: "episodi",
    weekly: "Settimanale",
    listen: "Ascolta",
    ctaTitle: "Non Perdere Nessun Episodio",
    ctaSubtitle: "Iscriviti alla nostra newsletter per ricevere notifiche sui nuovi podcast",
    subscribeNow: "Iscriviti Ora",
    loading: "Caricamento..."
  },
  
  // Contact Page
  contact: {
    title: "Contattaci",
    subtitle: "Siamo qui per ascoltarti. Inviaci un messaggio o contattaci attraverso i nostri canali social.",
    sendMessage: "Invia un Messaggio",
    fullName: "Nome Completo",
    fullNamePlaceholder: "Il tuo nome",
    email: "Email",
    emailPlaceholder: "tua@email.com",
    subject: "Oggetto",
    subjectPlaceholder: "Oggetto del messaggio",
    message: "Messaggio",
    messagePlaceholder: "Scrivi qui il tuo messaggio...",
    sendButton: "Invia Messaggio",
    sending: "Invio in corso...",
    contactInfo: "Informazioni di Contatto",
    emailLabel: "Email",
    emailAddress: "info@reteitalia.com.au",
    phoneLabel: "Telefono",
    phoneNumber: "1300 363 900",
    phoneHours: "Per le chiamate in diretta",
    addressLabel: "Studio",
    melbourneStudio: "Melbourne Studio",
    melbourneAddress: "35-37 Melville Road, Brunswick West VIC 3055 Australia",
    sydneyStudio: "Sydney Studio",
    sydneyAddress: "194-196 Norton St, Leichhardt NSW 2040 Australia",
    followUs: "Seguici sui Social",
    followUsDesc: "Resta connesso con noi attraverso i nostri canali social per aggiornamenti, notizie e contenuti esclusivi.",
    messageSent: "Messaggio Inviato!",
    messageSuccess: "Ti risponderemo il prima possibile.",
    messageError: "Errore",
    messageErrorDesc: "Si è verificato un errore. Riprova più tardi."
  },
  
  // Footer
  footer: {
    description: "La tua radio italiana in Australia. Musica, cultura e informazione 24/7.",
    quickLinks: "Link Rapidi",
    contact: "Contatti",
    followUs: "Seguici",
    allRightsReserved: "Tutti i diritti riservati"
  },
  
  // Common
  common: {
    live: "LIVE",
    offline: "OFFLINE",
    inDirect: "IN DIRETTA",
    loading: "Caricamento pubblicità..."
  }
};
